import { atom } from 'jotai';

function hasCachedAuth(): boolean {
  try {
    const stored = localStorage.getItem('hills_fsl_auth');
    if (!stored) return false;
    const { token, expiresAt } = JSON.parse(stored);
    return !!token && expiresAt > Date.now();
  } catch {
    return false;
  }
}

function getCachedToken(): string | undefined {
  try {
    const stored = localStorage.getItem('hills_fsl_auth');
    if (!stored) return undefined;
    const { token, expiresAt } = JSON.parse(stored);
    return token && expiresAt > Date.now() ? token : undefined;
  } catch {
    return undefined;
  }
}

const cachedAuth = hasCachedAuth();

// Authentication-related atoms to match digital-core-frontend pattern
export const accessTokenAtom = atom<string | undefined>(getCachedToken());

export const authErrorAtom = atom<string | null>(null);

export const authInProgressAtom = atom<boolean>(true);

export const isAuthenticatedAtom = atom<boolean>(cachedAuth);

export const isInitializedAtom = atom<boolean>(cachedAuth);

export const lastFailingEndpointAtom = atom<string | undefined>(undefined);

// Atom for tracking invalid sold_to errors
export const invalidSoldToErrorAtom = atom<string | null>(null);

//Atom for tracking non MVP user errors
export const invalidGroupUserErrorAtom = atom<boolean>(false);

// Atom for tracking retail user errors (USER_WITH_RETAIL_ACCOUNT)
export const retailUserErrorAtom = atom<boolean>(false);

// Atom for tracking profile completion required (MISSING_SOLD_TO_OR_POSTALCODE)
export const profileCompletionErrorAtom = atom<boolean>(false);

// Atom for tracking profile completion required (MISSING_SHELTER_IN_DB)
export const shelterMissingErrorAtom = atom<boolean>(false);

// Derived atom for checking if user has valid authentication
export const hasValidTokenAtom = atom((get) => {
  const token = get(accessTokenAtom);
  const isAuthenticated = get(isAuthenticatedAtom);
  return !!token && isAuthenticated;
});

// Admin-related atoms
export const userEmailAtom = atom<string | null>(null);

export const isAdminAtom = atom<boolean>(false);

export const adminCheckInProgressAtom = atom<boolean>(false);

// Preferred ship-to location from auth response
export const preferredShipToAtom = atom<string | null>(null);
